if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.extraItems = document.querySelectorAll('.extra-item input');
        this.optionalItems = document.querySelectorAll('.optional_product input');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);

        if (this.extraItems.length > 0 && Array.from(this.extraItems).some(input => input.checked) || this.optionalItems.length > 0 && Array.from(this.optionalItems).some(input => input.checked)) {
          let productsIDs = []

          productsIDs.push(this.form.querySelector('[name="id"]').value)

          this.extraItems.forEach(input => {
            productsIDs.push(input.dataset.variant)
          })

          this.optionalItems.forEach(input => {
            if (input.checked) {
              productsIDs.push(this.locateVariantIdInJson(input))
            }
          })

          let product_data = productsIDs.map((variantId, index) => {
            let quantity = 1
            let properties = {};
            let sellingPlan = null
            if (index === 0) {
              sellingPlan = this.form.querySelector('[name="selling_plan"]').value || null;

              if (this.form.querySelectorAll('[name^="properties"]').length > 0) {
                this.form.querySelectorAll('[name^="properties"]').forEach((item, index) => {
                  let propertyName = item.attributes.name.value.split('[')[1].split(']')[0];
                  properties[propertyName] = item.value;
                  //console.log('properties', properties)
                });
              }
            } else {
              // Determine id and optional productOrder if the item is an object returned by locateVariantIdInJson
              const isObject = typeof variantId === 'object' && variantId !== null;
              const resolvedId = isObject ? variantId.id : variantId;
              const productOrder = isObject ? variantId.productOrder : null;

              // Prefer `data-optional-product-order` from the returned object; fall back to using index
              let sellingPlanContainer = null;
              if (productOrder != null) {
                sellingPlanContainer = document
                .querySelector(`[data-optional-product-order="${productOrder}"]`)
                ?.querySelector('.selling-plans-list .selling_plan__item--product-after:not(.hidden) .optional_product--price__subscription');
              }

              if (!sellingPlanContainer) {
                sellingPlanContainer = document
                .querySelector(`[data-optional-product-order="${index}"]`)
                ?.querySelector('.selling-plans-list .selling_plan__item--product-after:not(.hidden) .optional_product--price__subscription');
              }

              // if still not found, optionally try to use the returned accordion element (for object entries)
              if (!sellingPlanContainer && isObject && variantId.accordion) {
                sellingPlanContainer = variantId.accordion
                .querySelector('.selling-plans-list .selling_plan__item--product-after:not(.hidden) .optional_product--price__subscription');
              }

              if (
                sellingPlanContainer &&
                document.querySelector('selling-plans-widget input[data-radio-type="one_time_purchase"]')?.checked === false
              ) {
                sellingPlan = sellingPlanContainer.dataset.sellingPlan;
              }

              // make sure to use resolvedId when returning the item
              variantId = resolvedId;
            }
            return {
              quantity: quantity,
              id: Number(variantId),
              selling_plan: sellingPlan,
              properties: properties
            };
          })

          product_data.reverse()

          let data = {
            items: product_data,
            sections: this.cart.getSectionsToRender().map(section => section.id),
            sections_url: window.location.pathname
          }

          config.body = JSON.stringify(data)
          config.headers['Content-Type'] = 'application/json'
        } else {
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      // javascript
      locateVariantIdInJson(input) {
        if (!input) return null;
        const value = String(input.value || '').trim();
        if (!value) return null;

        const variantSelects = input.closest('variant-selects');
        if (!variantSelects) return null;

        const accordion = input.closest('.product__accordion');

        const script =
          variantSelects.querySelector('script[type="application/json"][data-selected-variant-optional-product]') ||
          variantSelects.querySelector('script[type="application/json"]');
        if (!script) return null;

        let variants;
        try {
          variants = JSON.parse(script.textContent.trim());
          if (!Array.isArray(variants)) return null;
        } catch (e) {
          return null;
        }

        const valueParts = value.split('|').map(s => s.trim()).filter(Boolean);

        const buildResult = (variant) => ({
          id: String(variant.id),
          variant,
          input,
          accordion,
          productOrder: accordion?.dataset.optionalProductOrder ?? null
        });

        for (const v of variants) {
          const opts = (v.options || []).map(o => (o == null ? '' : String(o).trim()));
          const title = String(v.title || '').trim();
          const name = String(v.name || '').trim();

          if (name && name === value) return buildResult(v);
          if (title === value) return buildResult(v);
          if (opts.join(' | ') === valueParts.join(' | ')) return buildResult(v);

          if (valueParts.length > 0) {
            let allMatch = true;
            for (let i = 0; i < valueParts.length; i++) {
              if (opts[i] !== valueParts[i]) {
                allMatch = false;
                break;
              }
            }
            if (allMatch) return buildResult(v);
          }

          if (valueParts.length === 1 && opts[0] === valueParts[0]) return buildResult(v);
        }

        return null;
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
